import { Directive, ElementRef } from '@angular/core';
import { isAccessor } from 'typescript';

declare let jQuery;

@Directive({
  selector: '[dragDropSignature]'
})
export class DragDropSignatureDirective {
  private container: HTMLElement;
  private signature: HTMLImageElement;
  public pageLayers: any[];

  constructor() { }

  initialize(container) {
    if (this.container) {
      return;
    }

    this.pageLayers = [];
    this.container = container;

    container.childNodes.forEach((node, i) => {
      this.pageLayers.push([]);

      const layer = this.createLayerPage(i, node);
      container.appendChild(layer);
    })
  }

  private createLayerPage(index: number, node: HTMLElement) {
    const dimensions = node.getBoundingClientRect();

    const layer = document.createElement('div');
    layer.className = 'layer-signature'
    layer.style.width = `${dimensions.width}px`;
    layer.style.height = `${dimensions.height}px`;
    layer.style.top = `${node.offsetTop}px`;
    layer.style.left = `${node.offsetLeft}px`;
    layer.style.position = 'absolute';
    layer.setAttribute('layer', index.toString());
    const jLayer = jQuery(layer);

    jLayer.droppable({
      drop: (e, ui) => {
        if (ui.draggable[0].getAttribute('clone')) {
          return;
        }

        const Offset = jLayer.offset();
        const offsetX = Offset.left;
        const offsetY = Offset.top;

        let x, y;

        x = ui.offset.left - offsetX - 1;
        y = ui.offset.top - offsetY;

        this.createSignature(index, layer, x, y);
      }
    })

    return layer;
  }

  public makeItDraggable(element) {
    this.signature = element;
    jQuery(element).draggable({
      helper: 'clone',
    });
  }

  public createSignature(index, parent, x, y) {
    const clone = this.signature.cloneNode() as HTMLElement;
    const divParent = this.createResizableDiv(clone, x, y, index);
    this.pageLayers[index].push(divParent);

    let fromX = null;
    let fromY = null;
    jQuery(divParent).draggable({
      start: function (e) {
        fromX = divParent.style.left;
        fromY = divParent.style.top;
      },
      stop: function (e) {
        const parentRect = parent.getBoundingClientRect();

        if (e.clientX < parentRect.left || e.clientX > parentRect.right || e.clientY < parentRect.top || e.clientY > parentRect.bottom) {
          // Pas dedans
          divParent.style.left = fromX;
          divParent.style.top = fromY;
        }
      }
    });

    parent.appendChild(divParent);
    return divParent;
  }

  private createResizableDiv(signatureImage, x, y, index) {
    const actualNumElement = this.pageLayers[index].length;
    const resizableDiv = document.createElement('div');
    resizableDiv.style.position = 'absolute';
    resizableDiv.style.left = `${x}px`;
    resizableDiv.style.top = `${y}px`;
    resizableDiv.style.width = `100px`;
    resizableDiv.style.height = `50px`;
    resizableDiv.style.zIndex = '10';
    resizableDiv.setAttribute('clone', 'true');
    resizableDiv.className = 'resizable';
    resizableDiv.setAttribute('num', actualNumElement);

    const resizers = document.createElement('div');
    resizers.className = 'resizers';
    resizableDiv.appendChild(resizers);

    const resizerTopLeft = document.createElement('div');
    resizerTopLeft.className = 'resizer top-left';
    resizers.appendChild(resizerTopLeft);

    // const resizerTopRight = document.createElement('div');
    // resizerTopRight.className = 'resizer top-right';
    // resizers.appendChild(resizerTopRight);

    const close = document.createElement('div');
    close.className = 'resizer close';
    resizers.appendChild(close);

    close.addEventListener('click', () => {
      this.removeElement(index, actualNumElement);
    });

    const resizerBottomLeft = document.createElement('div');
    resizerBottomLeft.className = 'resizer bottom-left';
    resizers.appendChild(resizerBottomLeft);

    const resizerBottomRight = document.createElement('div');
    resizerBottomRight.className = 'resizer bottom-right';
    resizers.appendChild(resizerBottomRight);

    signatureImage.style.position = 'absolute';
    signatureImage.style.width = '100%';
    signatureImage.style.height = '100%';
    resizers.appendChild(signatureImage);

    this.makeResizableDiv(resizableDiv);

    return resizableDiv;
  }

  private removeElement(index, num) {
    const elIndex = this.pageLayers[index].findIndex(el => el.getAttribute('num') === num.toString());
    const el = this.pageLayers[index][elIndex];

    el.parentElement.removeChild(el);
    this.pageLayers[index].splice(elIndex, 1);
  }

  private makeResizableDiv(div) {
    const element = div;
    const resizers = div.querySelectorAll('.resizer');
    const minimum_size = 20;
    let original_width = 0;
    let original_height = 0;
    let original_x = 0;
    let original_y = 0;
    let original_mouse_x = 0;
    let original_mouse_y = 0;
    for (let i = 0; i < resizers.length; i++) {
      const currentResizer = resizers[i];
      currentResizer.addEventListener('mousedown', function (e) {
        e.stopPropagation();
        e.preventDefault();
        original_width = parseFloat(getComputedStyle(element, null).getPropertyValue('width').replace('px', ''));
        original_height = parseFloat(getComputedStyle(element, null).getPropertyValue('height').replace('px', ''));
        original_x = element.style.left;
        original_y = element.style.top;
        original_mouse_x = e.pageX;
        original_mouse_y = e.pageY;
        window.addEventListener('mousemove', resize)
        window.addEventListener('mouseup', stopResize)
      })

      function resize(e) {
        if (currentResizer.classList.contains('bottom-right')) {
          const width = original_width + (e.pageX - original_mouse_x);
          const height = original_height + (e.pageY - original_mouse_y)
          if (width > minimum_size) {
            element.style.width = width + 'px'
          }
          if (height > minimum_size) {
            element.style.height = height + 'px'
          }
        }
        else if (currentResizer.classList.contains('bottom-left')) {
          const height = original_height + (e.pageY - original_mouse_y)
          const width = original_width - (e.pageX - original_mouse_x)
          if (height > minimum_size) {
            element.style.height = height + 'px'
          }
          if (width > minimum_size) {
            element.style.width = width + 'px'
            element.style.left = original_x + (e.pageX - original_mouse_x) + 'px'
          }
        }
        else if (currentResizer.classList.contains('top-right')) {
          const width = original_width + (e.pageX - original_mouse_x)
          const height = original_height - (e.pageY - original_mouse_y)
          if (width > minimum_size) {
            element.style.width = width + 'px'
          }
          if (height > minimum_size) {
            element.style.height = height + 'px'
            element.style.top = original_y + (e.pageY - original_mouse_y) + 'px'
          }
        }
        else {
          const width = original_width - (e.pageX - original_mouse_x)
          const height = original_height - (e.pageY - original_mouse_y)
          if (width > minimum_size) {
            element.style.width = width + 'px'
            element.style.left = original_x + (e.pageX - original_mouse_x) + 'px'
          }
          if (height > minimum_size) {
            element.style.height = height + 'px'
            element.style.top = original_y + (e.pageY - original_mouse_y) + 'px'
          }
        }
      }

      function stopResize() {
        window.removeEventListener('mousemove', resize)
      }
    }
  }

  public getSignPositionsForPages() {
    const childNodes: HTMLElement[] = this.container.childNodes as any;

    return this.pageLayers
      .map((arr, index) => {
        const parentPos = childNodes[index].getBoundingClientRect();

        return arr.map((el) => {
          const elPost = el.getBoundingClientRect();
          const relativeWidth = (elPost.width / parentPos.width) * 100;
          const relativeHeight = (elPost.height / parentPos.height) * 100;

          let relativeX = (el.offsetLeft / parentPos.width) * 100;
          let relativeY = (el.offsetTop / parentPos.height) * 100;

          return {
            widthPercent: relativeWidth,
            heightPercent: relativeHeight,
            xPercent: relativeX,
            yPercent: relativeY,
            pageIndex: index
          }
        });
      })
      .reduce((acc, array) => [...acc, ...array], []);
  }
}
